import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = signed out
  const [locations, setLocations] = useState([]);

  const applySession = (data) => {
    if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
    setLocations(data.locations || []);
    return data;
  };

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      applySession(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
      setLocations([]);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => applySession((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => applySession((await api.post("/auth/register", payload)).data);
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    setLocations([]);
  };

  return (
    <AuthContext.Provider value={{ user, locations, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const homeFor = (user) => (user?.role === "admin" ? "/admin" : "/dashboard");
